import { Component, inject, OnInit } from '@angular/core';
import { DxButtonComponent, DxDataGridComponent } from 'devextreme-angular';
import { DxiColumnComponent, DxoEditingComponent, DxoLookupComponent } from 'devextreme-angular/ui/nested';
import { Articoli, ArticoliReqModel } from 'src/app/models/articoli';
import { ArticoliConsegnaModel } from 'src/app/models/articoli-consegna-model';
import { Dipendente } from 'src/app/models/dipendente';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-dashboard-guidata',
  templateUrl: './dashboard-guidata.component.html',
  styleUrls: ['./dashboard-guidata.component.scss'],
  imports: [DxButtonComponent, DxDataGridComponent, DxoEditingComponent, DxiColumnComponent, DxoLookupComponent],
})
export class DashboardGuidataComponent implements OnInit {
  private navigatorService = inject(NavigatorService);
  private dipendentiService = inject(DipendentiService);
  private articoliService = inject(ArticoliService);

  listDipendenti: Dipendente[] = [];
  listArticoli: Articoli[] = [];

  ngOnInit() {
    this.loadArticoli();
    this.loadLookup();
  }

  loadLookup() {
    //Lista dipendenti
    this.dipendentiService.listTemp().subscribe({
      next: (res) => {
        this.listDipendenti = res;
      }
    });
  }

  loadArticoli() {
    const req: ArticoliReqModel = {
      idDipendente: 0,
      dataMovimento: new Date(),
    };

    this.articoliService.consegnePrevisteGiornaliere(req).subscribe({
      next: (res) => {
        this.listArticoli = res;
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio(
            'Errore recupero articoli previsti da consegnare',
            'error',
          );
        }
      },
    });
  }

  getDipendenteDisplayExpr(item: Dipendente) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.nominativo;
  }

  onConsegnaArticoli() {
    this.navigatorService.goToConsegnaGiornaliera();
  }

  onRestituzioneArticoli() {
    this.navigatorService.goToRestituzioneGiornaliera();
  }
}
